export default "__VITE_ASSET__CJ$z0qPO__"